// Bereiche späterer Stufen: eigener Navigationspunkt mit dem, was dort kommt.

import { HowTo, Later, PageHead } from "../ui";

export const PLANNED: { key: string; label: string; stage: number; text: string; points: string[]; built?: boolean }[] = [
  {
    key: "kategorien", label: "Kategorien & Rotation", stage: 3, built: true,
    text: "Kategorien bestimmen, was gesendet wird; das Rotationsboard zeigt, welcher Song wo rotiert.",
    points: [
      "Kategorien mit Ziel-%, Typ, Farbe, Verarbeitungsprofil, Now-Playing-Label, Inhaltsregeln",
      "Rotationsboard: Spalte = Kategorie, Karte = Song, Drag & Drop, Gewichte, Mehrfachauswahl",
      "Rotationseinstellungen je Kategorie (Reichweite, Ruhezeit, Kadenz, Spin-Obergrenzen)",
      "Massen-Codierung (Tempo, Stimmung, Energie, Stimmgeschlecht, Textur, Ära)",
      "Rotationsziele pro Song/Tag, „Uhren bauen“ aus Zielen",
    ],
  },
  {
    key: "regeln", built: true, label: "Regeln", stage: 4,
    text: "Separation und Regeln entscheiden, welcher Song in einen Slot darf.",
    points: [
      "Interpret-/Song-Separation mit Presets Eng/Ausgewogen/Locker",
      "Regelbaum über 10 Attribute, unbrechbar/brechbar mit Priorität",
      "Planweite Optimierung, „Auswahl erklären“ als Trockenlauf",
    ],
  },
  {
    key: "uhren", built: true, label: "Uhren", stage: 4,
    text: "Eine Uhr beschreibt den Ablauf einer Stunde.",
    points: [
      "Tortenansicht und Spaltenübersicht, Editor Einfach/Erweitert",
      "Elemente: Musik, Jingle, Sweeper, Promo, Werbeblock, Nachrichten, Zeitansage, Voicetrack-Slot, Programm, Relay …",
      "Harte/weiche Zeiten, Stretch & Squeeze, Testlauf",
    ],
  },
  {
    key: "wochenraster", built: true, label: "Wochenraster", stage: 4,
    text: "Welche Uhr wann läuft: die Woche mit Uhren bemalen.",
    points: ["So–Sa + Feiertage, 0–24 h, Malen mit Uhr-Pinsel, Raster bis 1 min", "Feiertage, Saisons, wiederkehrende Blöcke, Konfliktwarnungen"],
  },
  {
    key: "sendeplan", built: true, label: "Sendeplan", stage: 4,
    text: "Der fertige Ablauf Titel für Titel – 7 Tage im Voraus, vollautomatisch.",
    points: [
      "Auto-Fill, Tag generieren, Stundenköpfe mit Füllbalken und Abweichung",
      "Rechtsklick: Ersetzen, Danach einfügen, VT hier, Überspringen; Drag zum Umsortieren",
      "Sendeplan teilen (Nur-Lese-Link), Export/Import, Konflikt-Zähler",
    ],
  },
  {
    key: "analyse", built: true, label: "Analyse", stage: 4,
    text: "Wie sauber ist der Plan, wie dreht sich die Musik?",
    points: ["Recap: sauber / gelockert / Lücken", "Kategorien-Mix gegen Ziel", "Song-Turnover, As-aired-Report als CSV"],
  },
  {
    key: "imaging", built: true, label: "Imaging & Drop-ins", stage: 5,
    text: "Jingles, Sweeper und Drop-ins automatisch an die richtige Stelle.",
    points: ["Vorlagen/Regeln nach Häufigkeit, Tageszeit, Kontext", "Über das Intro des Folgetitels", "Drop-ins auf Song-Rampen", "Asset-Pools"],
  },
  {
    key: "nachrichten", built: true, label: "Nachrichten", stage: 5,
    text: "Nachrichten per URL abholen und über ein Musikbett senden.",
    points: ["Abruf per URL zu festen Zeiten", "Musikbett mit Ducking", "Ersatz, wenn nichts kommt"],
  },
  {
    key: "werbung", built: true, label: "Werbung (Traffic)", stage: 5,
    text: "Kunden, Kampagnen und Spots – gleichmäßig verteilt.",
    points: ["Kunde → Kampagne → Spots mit Ziel-Plays und Laufzeit", "Kunden-Separation, Werbeblöcke aus der Uhr gefüllt", "Pacing-Report Soll/Ist, CSV"],
  },


  {
    key: "voicetracking", built: true, label: "Voicetracking", stage: 6,
    text: "Moderationen vorproduzieren, die genau an ihrer Stelle im Sendeplan landen.",
    points: ["Recorder mit Ende vorher / Anfang nachher", "Übersicht Tage × Stunden rot/gelb/grün", "Gruppen-VT an mehrere Sender", "VT über Intro bis Post"],
  },
];

export function Planned({ which }: { which?: string }) {
  const p = PLANNED.find((x) => x.key === which) ?? PLANNED[0];
  return (
    <div>
      <PageHead title={p.label} sub={`kommt in Stufe ${p.stage}`} />
      <HowTo text={p.text} chapter="plan" />
      <Later stage={p.stage} title={p.label} points={p.points} />
    </div>
  );
}
